import Immutable from 'immutable';
import { GET_CARS } from '../constants';

const INITIAL_STATE = Immutable.fromJS({cars: [], carsCount: 0});

export default function (state = INITIAL_STATE, action)
{
	let nextState = state.toJS();

	switch (action.type) {
		case GET_CARS:
            nextState.cars = action.payload.rows
            nextState.carsCount = action.payload.count
        break;
        default:

        break;
	}

	return state.merge(nextState);
}
